import { offersReducer } from './offers/offers.reducer';

export const STORE_CONFIG = {
	offers: offersReducer,
};
